import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const FAQS = [{
  q: '¿Necesito saber de tecnología para usar este sistema?',
  a: 'No. Si sabés enviar un mensaje de WhatsApp, podés usar este sistema. Está diseñado paso a paso para docentes sin experiencia técnica previa.'
}, {
  q: '¿Funciona para mi materia y nivel?',
  a: 'Sí. El sistema está diseñado para todas las áreas curriculares y niveles del sistema educativo argentino: Inicial, Primaria y Secundaria.'
}, {
  q: '¿La IA reemplaza mi criterio como docente?',
  a: 'No. La IA es una herramienta. Tu criterio pedagógico siempre es el que define qué usar y cómo adaptarlo a tu grupo real.'
}, {
  q: '¿Cuánto tiempo tarda en verse resultados?',
  a: 'La mayoría de las docentes reportan resultados desde la primera semana de uso. El sistema está diseñado para dar resultados inmediatos.'
}, {
  q: '¿Cómo accedo al material?',
  a: 'Una vez confirmado el pago, recibís todos los PDFs directamente en tu email en menos de 5 minutos.'
}, {
  q: '¿Y si no me sirve?',
  a: 'Tenés 7 días de garantía total. Si por cualquier motivo técnico no podés acceder al material, te devolvemos el 100% de tu dinero sin preguntas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-zinc-950" data-id="element-107">
      <div className="max-w-3xl mx-auto px-4" data-id="element-108">
        <div className="text-center mb-12" data-id="element-109">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-black uppercase tracking-tight text-white" data-id="element-110">
            Preguntas Frecuentes
          </motion.h2>
        </div>

        <div className="space-y-4" data-id="element-111">
          {FAQS.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-zinc-900 border border-zinc-800 rounded-xl overflow-hidden" data-id="element-112">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-zinc-800/50 transition-colors" data-id="element-113">
                <span className="font-bold text-white pr-8" data-id="element-114">{faq.q}</span>
                <ChevronDownIcon className={`w-5 h-5 flex-shrink-0 transition-transform duration-300 ${openIndex === idx ? 'rotate-180 text-yellow-500' : 'text-gray-500'}`} data-id="element-115" />
              </button>

              <AnimatePresence data-id="element-116">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-117">
                    <div className="px-6 pb-5 text-gray-400 leading-relaxed border-t border-zinc-800/50 pt-4" data-id="element-118">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}